import rootReducer from './redux-saga/reducers/rootReducer';
import rootSagas from './redux-saga/sagas/index';

export default function getRootModule() {
  return {
    id: 'UPDATE_BUSSINES_RULES',
    reducerMap: {
      UPDATE_BUSSINES_RULES: rootReducer,
    },
    sagas: [rootSagas],
  };
}
